// extracted by mini-css-extract-plugin
export default {"dots":"dots___dots___ea40e8af","dot":"dots___dot___c0d5c605"};